module.exports = __webpack_public_path__ + "static/media/portfolio2.6c72007c.png";